import './App.css'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import {
  createTheme,
  ThemeProvider,
  ScopedCssBaseline,
  Box,
} from '@mui/material'
import { Content } from './Content'
import cursorImage from './mouseimage.png'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
function App() {
  const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          // Force custom cursor for body
          body: {
            cursor: `url(${cursorImage}), auto !important`,
          },
          // Force child elements to inherit that cursor
          '*': {
            cursor: 'inherit !important',
          },
        },
      },
    },
    typography: {
      fontFamily: 'arial, sans-serif',
      allVariants: {
        lineHeight: 1.1, // Adjust this value as needed
      },
    },
    palette: {
      background: {
        // default: 'rgb(250, 248, 241)',
      },
    },
  })

  return (
    <div className="custom-cursor-wrapper">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ScrollToTop />

          <Routes>
            <Route
              path="/*"
              element={
                <ScopedCssBaseline>
                  <Content />
                </ScopedCssBaseline>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  )
}

export default App
